import { CURRENCY_MARK, DEFAULT_LANGUAGE } from "../common/constants";
import { Category, CategoryItem } from "../types";

export const getBaseLanguage = () => {
  const browserLanguage = window.navigator.language.replace(/-.*$/, "");
  return ["ja", "ko", "en"].includes(browserLanguage)
    ? browserLanguage
    : DEFAULT_LANGUAGE;
};

export const getCurrencyUnit = (currency: string) => {
  switch(currency) {
    default:
      return CURRENCY_MARK.jpy;
      // return CURRENCY_MARK.non;
    case "jpy":
      return CURRENCY_MARK.jpy;
    case "krw":
      return CURRENCY_MARK.krw;
    case "usd":
      return CURRENCY_MARK.usd;
  }
}

export const changeCategoryLabel = (lang: string, category: Category): Category => {
  if (!category) return {} as Category;

  const { userId, expense: expenses, income: incomes } = category;

  const income = incomes.map((t: CategoryItem) => ({
    ...t,
    label: t.otherLangs?.find((tl) => tl.lang === lang)?.label as string,
  }));
  const expense = expenses.map((t) => ({
    ...t,
    label: t.otherLangs?.find((tl) => tl.lang === lang)?.label as string,
  }));

  return {
    userId,
    expense: expense || ([] as CategoryItem[]),
    income: income || ([] as CategoryItem[]),
  };
};